import { Link } from '@/navigation';
import { Page } from '@/payload/payload-types';
import { Button } from '../../_components/Button';

type CtaButtonType = Extract<Page['layoutBlocks'][0], { blockType: 'ctaButton' }>;
type CtaButtonProps = Omit<CtaButtonType, 'blockType'> & {
	className?: string;
};

export const CtaButton: React.FC<CtaButtonProps> = ({ ctaButton, className }) => {
	if (!ctaButton) return null;

	const { type, appearance, label, reference, url } = ctaButton;
	const getHref = (ctaButton: CtaButtonProps['ctaButton']) => {
		if (!type) throw new Error('no link type provided for hero link');

		if (ctaButton.type === 'custom') {
			return ctaButton.url;
		} else if (ctaButton.reference) {
			const collection = ctaButton.reference.value;
			if (typeof collection === 'string') {
				throw new Error('Bad depth for hero link');
			}

			if (!collection?.slug) {
				throw new Error('Slug missing for hero link');
			}

			return `/${collection.slug}`; //TODO: siia ei sobi slug, vaja on saada kogu path
		} else {
			throw new Error(`Cta button missing reference: ${JSON.stringify(ctaButton)}`);
		}
	};

	const href = getHref(ctaButton);
	const targetProps = type === 'custom' ? { target: '_blank' } : {};

	if (!href) {
		return null;
	}

	return (
		//@ts-expect-error CTA button can link to external pages as well.
		<Link className={className} href={href} {...targetProps}>
			<Button intent={appearance === 'primary' ? 'primary' : 'secondary'}>{label}</Button>
		</Link>
	);
};
